import React, { useState } from 'react';
import { History, Clock, Trash2, RotateCcw, X } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент для отображения истории конвертаций
 */
const HistoryList = ({ 
  history, 
  clearHistory, 
  repeatConversion,
  unitDefinitions 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Если история пуста
  if (!history || history.length === 0) {
    return null;
  }
  
  // Определяем, сколько элементов истории показывать
  const displayHistory = isExpanded ? history : history.slice(0, 3);
  
  // Форматирование даты
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6 mb-8 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <History className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            История конвертаций
          </h2>
        </div>
        
        <Button
          size="sm"
          variant="outline"
          onClick={clearHistory}
          icon={<Trash2 className="w-4 h-4" />}
          className="text-red-500 border-red-200 hover:bg-red-50 dark:border-red-800 dark:hover:bg-red-900/20"
        >
          Очистить
        </Button>
      </div>
      
      <div className="space-y-3">
        {displayHistory.map((item) => {
          const fromUnitInfo = unitDefinitions[item.fromUnit];
          const toUnitInfo = unitDefinitions[item.toUnit];
          
          return (
            <div 
              key={item.id} 
              className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-gray-400 dark:text-gray-500 flex-shrink-0" />
                
                <div>
                  <div className="font-medium text-gray-800 dark:text-gray-200">
                    {item.fromValue} {fromUnitInfo?.shortName || item.fromUnit} = {item.toValue} {toUnitInfo?.shortName || item.toUnit}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    {formatDate(item.date)}
                  </div>
                </div>
              </div>
              
              <button
                onClick={() => repeatConversion(item)}
                className="p-1.5 text-gray-500 hover:text-purple-500 rounded-full hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors"
                title="Повторить конвертацию"
              >
                <RotateCcw className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>
      
      {/* Кнопка "Показать больше"/"Скрыть" */}
      {history.length > 3 && (
        <div className="mt-4 text-center">
          <Button
            size="sm"
            variant="link"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? (
              <>
                <X className="w-4 h-4 mr-1" />
                Скрыть
              </>
            ) : (
              <>
                <History className="w-4 h-4 mr-1" />
                Показать все ({history.length})
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default HistoryList;